const mostExpensiveOverview = [
  {
      "city": "New York City",
      "price": "28400"
  },
  {
      "city": "Los Angeles",
      "price": "17800"
  },
  {
      "city": "Palm Beach",
      "price": "17500"
  },
  {
      "city": "Miami Beach",
      "price": "17200"
  },
  {
      "city": "The Bay Area",
      "price": "15500"
  }
];


export {mostExpensiveOverview};